import { useLocation } from 'react-router';

import useRequestId from '@/hooks/useRequestId';

const useAutoCredRequestId = () => {
  const location = useLocation();
  const { requestId } = useRequestId();

  const locationState = location.state as { requestId?: string } | null;

  const computedRequestId: string = requestId || locationState?.requestId || '';

  return { requestId: computedRequestId };
};

export default useAutoCredRequestId;
